import { Coordinate, GeoData } from '@breakroom-nx/helpers';
import axios from 'axios';

// Temporary reverse geo-location API
// Might be better to use Google's later, but this one's free (3000 calls/day)
// https://apidocs.geoapify.com/docs/geocoding/reverse-geocoding/#about
const GEOAPIFY_API_KEY = '912b36f0cd754b33b565ca827b7a71fe';
const GEOAPIFY_ENDPOINT = `https://api.geoapify.com/v1/geocode/reverse`;

export const reverseGeo = async (
  coordinate: Coordinate
): Promise<GeoData | undefined> => {
  const url =
    GEOAPIFY_ENDPOINT +
    `?lat=${coordinate.latitude}&lon=${coordinate.longitude}&format=json&apiKey=${GEOAPIFY_API_KEY}`;

  try {
    const res = await axios.get(url);
    const result = res.data.results[0];
    // console.log('Geoapify response:', res.data);
    // const locationName = result.name;

    return {
      city: result.city,
      country: result.country,
      code: result.country_code,
    };
  } catch (error) {
    // console.log(error);
    return undefined;
  }
};

export const regionFlag = (country: string) => {
  const code = country
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...code);
};
